/* ============================================================
   RINCÓN DEL VALLE — Nueva Home Premium · JS
   Vanilla, sin dependencias. Todo con guardas: nada falla si
   un componente no está presente.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Header: sombra al hacer scroll ----------
     También marca <html> con .rdv-scrolled para que la barra de
     envío gratis (app) solo se muestre arriba del todo. */
  var header = doc.querySelector('[data-header]');
  var lastState = false;
  var onScroll = function () {
    var scrolled = window.scrollY > 8;
    if (scrolled !== lastState) {
      if (header) { header.classList.toggle('is-scrolled', scrolled); }
      doc.documentElement.classList.toggle('rdv-scrolled', scrolled);
      lastState = scrolled;
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- 2. Topbar: mensajes rotativos ---------- */
  var msgs = doc.querySelectorAll('[data-topbar-msg]');
  if (msgs.length > 1) {
    var current = 0;
    var rotate = function () {
      msgs[current].classList.remove('is-active');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('is-active');
    };
    var timer = setInterval(rotate, 4500);
    doc.addEventListener('visibilitychange', function () {
      if (doc.hidden) { clearInterval(timer); }
      else { timer = setInterval(rotate, 4500); }
    });
  }

  /* ---------- 3. Drawer móvil ---------- */
  var drawer = doc.querySelector('[data-drawer]');
  var drawerOpenBtn = doc.querySelector('[data-drawer-open]');
  if (drawer && drawerOpenBtn) {
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;

    var openDrawer = function () {
      lastFocus = doc.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      doc.body.style.overflow = 'hidden';
      var firstLink = drawer.querySelector('a, button, summary');
      if (firstLink) { firstLink.focus(); }
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      doc.body.style.overflow = '';
      if (lastFocus) { lastFocus.focus(); }
    };

    drawerOpenBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) { closeDrawer(); }
    });
  }

  /* ---------- 4. Dropdowns de navegación (teclado + táctil) ---------- */
  var NAV_BTN = 'button.nav__link, button.rdvh__link';
  var navItems = doc.querySelectorAll('[data-nav-item]');
  var closeAllNav = function () {
    navItems.forEach(function (item) {
      item.classList.remove('is-open');
      var b = item.querySelector(NAV_BTN);
      if (b) { b.setAttribute('aria-expanded', 'false'); }
    });
  };
  navItems.forEach(function (item) {
    var btn = item.querySelector(NAV_BTN);
    if (!btn) { return; }
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      closeAllNav();
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  doc.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) { closeAllNav(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllNav(); }
  });

  /* ---------- 5. Carruseles: flechas ---------- */
  doc.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-carousel]');
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) { return; }

    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    var step = function (dir) {
      track.scrollBy({
        left: dir * track.clientWidth * 0.85,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
    };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- 6. Animaciones de entrada ---------- */
  var revealEls = doc.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !prefersReduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- 7. FAQ: cerrar las demás al abrir una ---------- */
  var faqItems = doc.querySelectorAll('[data-faq] details');
  faqItems.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        faqItems.forEach(function (other) {
          if (other !== d) { other.open = false; }
        });
      }
    });
  });

  /* ---------- 8. Newsletter (prototipo: confirmación local) ----------
     En producción Shopify este formulario se sustituye por el
     embed de Klaviyo o {% form 'customer' %}. */
  var nlForm = doc.querySelector('[data-newsletter-form]');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = nlForm.querySelector('input[type="email"]');
      if (email && email.value && email.checkValidity()) {
        var section = nlForm.closest('.newsletter');
        if (section) { section.classList.add('is-done'); }
      }
    });
  }

  /* ---------- 9. Búsqueda: enviar a Shopify ---------- */
  doc.querySelectorAll('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  });

  /* ---------- 10. Carrito: total siempre sincronizado +
       barra de pago fija en móvil ---------- */
  (function () {
    var footer = doc.getElementById('main-cart-footer');
    var emptyCart = doc.querySelector('cart-items.is-empty');
    if (!footer || emptyCart) { return; }
    var sectionId = footer.getAttribute('data-id');

    function totalText() {
      var el = footer.querySelector('.totals__total-value');
      return el ? el.textContent.trim() : '';
    }

    /* Barra fija de pago (solo visible <990px vía CSS) */
    var bar = doc.createElement('div');
    bar.className = 'rdv-paybar';
    bar.innerHTML =
      '<div class="rdv-paybar__total">' +
      '<span class="rdv-paybar__label">Total</span>' +
      '<span class="rdv-paybar__value" data-paybar-total></span></div>' +
      '<button type="button" class="rdv-paybar__btn">Pagar pedido</button>';
    doc.body.appendChild(bar);
    doc.documentElement.classList.add('rdv-has-paybar');

    function updateBar() {
      var v = bar.querySelector('[data-paybar-total]');
      if (v) { v.textContent = totalText(); }
    }
    bar.querySelector('button').addEventListener('click', function () {
      var real = footer.querySelector('#checkout, button[name="checkout"], [name="checkout"]');
      if (real) { real.click(); }
    });
    updateBar();

    /* Re-render del resumen tras cualquier cambio del carrito.
       (Cubre el caso en que el tema/apps no refrescan el total.) */
    var timer;
    function refreshFooter() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch(window.location.pathname + '?section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            try {
              var d2 = new DOMParser().parseFromString(html, 'text/html');
              var src = d2.querySelector('.js-contents');
              var dst = footer.querySelector('.js-contents');
              if (src && dst) { dst.innerHTML = src.innerHTML; }
            } catch (e) { /* noop */ }
            updateBar();
          })
          .catch(function () {});
      }, 400);
    }
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
        if (/\/cart\/(change|add|update|clear)/.test(u)) {
          p.then(refreshFooter, function () {});
        }
      } catch (e) { /* noop */ }
      return p;
    };
  })();

  /* ---------- 11. Newsletter → Klaviyo (misma cuenta que el popup) ---------- */
  doc.querySelectorAll('[data-klaviyo-newsletter]').forEach(function (form) {
    var company = (form.getAttribute('data-company') || '').trim();
    var listId = (form.getAttribute('data-list') || '').trim();
    var source = form.getAttribute('data-source') || 'Newsletter';
    var emailEl = form.querySelector('[data-nl-email]');
    var btn = form.querySelector('[data-nl-submit]');
    var okEl = form.parentNode.querySelector('[data-nl-ok]');
    var errEl = form.parentNode.querySelector('[data-nl-err]');
    if (!emailEl || !btn) { return; }

    var btnText = btn.textContent.trim();
    function showErr(msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    }
    function done() {
      form.hidden = true;
      if (errEl) { errEl.hidden = true; }
      if (okEl) { okEl.hidden = false; }
    }
    function identifyKlaviyo(email) {
      try {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['identify', { '$email': email, '$source': source }]);
        window.klaviyo.push(['track', 'Suscripción Newsletter', { source: source }]);
      } catch (e) { /* noop */ }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) { errEl.hidden = true; }
      var email = (emailEl.value || '').trim();
      if (!email || !emailEl.checkValidity()) {
        emailEl.focus();
        showErr('Introduce un correo electrónico válido.');
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Enviando…';

      var restore = function () { btn.disabled = false; btn.textContent = btnText; };

      // Ruta principal: suscripción real a la lista (consentimiento) vía Client API
      if (company && listId) {
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.ok || r.status === 202) { identifyKlaviyo(email); done(); }
          else { restore(); showErr('No se pudo completar la suscripción. Inténtalo de nuevo.'); }
        }).catch(function () {
          restore(); showErr('No se pudo completar la suscripción. Revisa tu conexión.');
        });
        return;
      }

      // Fallback sin list_id: crear/identificar perfil + evento (configurar lista luego)
      if (company) {
        identifyKlaviyo(email);
        done();
      } else {
        restore();
        showErr('Configuración de Klaviyo incompleta.');
      }
    });
  });

  /* ---------- 12. Barra "Añadir al carrito" sticky propia (PDP) ---------- */
  (function () {
    var addBtn = doc.querySelector('product-form button[name="add"]')
      || doc.querySelector('product-form [name="add"]')
      || doc.querySelector('form[action*="/cart/add"] [name="add"]')
      || doc.querySelector('[name="add"]');
    var form = addBtn ? addBtn.closest('form') : null;
    if (!form || !addBtn) { return; }

    var h1 = doc.querySelector('.product__title h1, .product__info-container h1, h1');
    var priceEl = doc.querySelector('.product__info-container .price__regular .price-item, .product .price .price-item--sale, .product .price .price-item--regular, .product .price .price-item');
    var img = doc.querySelector('.product__media img, .product__media-item img, .product-media-container img');

    var bar = doc.createElement('div');
    bar.className = 'rdv-pdp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Añadir al carrito');
    var imgHtml = img ? '<div class="rdv-pdp-bar__media"><img src="' + img.currentSrc + '" alt="" width="48" height="48"></div>' : '';
    bar.innerHTML =
      imgHtml +
      '<div class="rdv-pdp-bar__info">' +
      '<span class="rdv-pdp-bar__title">' + (h1 ? h1.textContent.trim() : '') + '</span>' +
      '<span class="rdv-pdp-bar__price" data-pdp-price>' + (priceEl ? priceEl.textContent.trim() : '') + '</span>' +
      '<span class="rdv-pdp-bar__variant" data-pdp-variant hidden></span>' +
      '</div>' +
      '<button type="button" class="rdv-pdp-bar__btn" data-pdp-add>Añadir al carrito</button>';
    doc.body.appendChild(bar);

    /* QA móvil 03/11/2026: la barra pulsaba el botón real con la variante que el tema deja
       marcada por defecto, así que metía una talla que el cliente no había elegido
       (Noa mujer → Gris / L; Romy → 30). Si la ficha tiene más de una opción posible y el
       cliente aún no ha tocado el selector, la barra le lleva al selector en vez de añadir.
       Cuando solo hay una combinación (p. ej. Lexhis 39 / XL) la barra la enseña. */
    var barBtn = bar.querySelector('[data-pdp-add]');
    var barVariant = bar.querySelector('[data-pdp-variant]');
    var eligio = false;

    function getPicker() {
      return doc.querySelector('variant-selects, variant-radios');
    }

    function gruposConEleccion() {
      var picker = getPicker();
      var grupos = [];
      if (!picker) { return grupos; }
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        if (fs.querySelectorAll('input[type="radio"]').length > 1) {
          var lg = fs.querySelector('legend');
          grupos.push(lg ? lg.textContent.trim() : '');
        }
      });
      picker.querySelectorAll('select').forEach(function (s) {
        if (s.options.length > 1) {
          var lb = picker.querySelector('label[for="' + s.id + '"]');
          grupos.push(lb ? lb.textContent.trim() : '');
        }
      });
      return grupos;
    }

    function textoVariante() {
      var picker = getPicker();
      var partes = [];
      if (!picker) { return ''; }
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        if (c) { partes.push(c.value); }
      });
      picker.querySelectorAll('select').forEach(function (s) {
        if (s.value) { partes.push(s.value); }
      });
      return partes.join(' · ');
    }

    function etiquetaEleccion(grupos) {
      var t = grupos.join(' ').toLowerCase();
      if (t.indexOf('talla') !== -1) { return 'Elige tu talla'; }
      if (t.indexOf('color') !== -1) { return 'Elige el color'; }
      return 'Elige una opción';
    }

    function pintarBarra() {
      var grupos = gruposConEleccion();
      var falta = grupos.length > 0 && !eligio;
      barBtn.textContent = falta ? etiquetaEleccion(grupos) : 'Añadir al carrito';
      var tv = falta ? '' : textoVariante();
      barVariant.textContent = tv;
      barVariant.hidden = !tv || tv === 'Default Title';
    }

    barBtn.addEventListener('click', function () {
      if (gruposConEleccion().length > 0 && !eligio) {
        var picker = getPicker();
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker.classList.remove('rdv-pick-needed');
        void picker.offsetWidth;
        picker.classList.add('rdv-pick-needed');
        return;
      }
      (doc.querySelector('product-form button[name="add"]') || addBtn).click();
    });

    doc.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects, variant-radios')) { return; }
      eligio = true;
      var picker = getPicker();
      if (picker) { picker.classList.remove('rdv-pick-needed'); }
      setTimeout(function () {
        var pe = doc.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular, .product .price .price-item');
        var t = bar.querySelector('[data-pdp-price]');
        if (pe && t) { t.textContent = pe.textContent.trim(); }
        pintarBarra();
      }, 350);
    });

    pintarBarra();

    /* Mostrar la barra solo cuando el botón real de añadir queda fuera de vista */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(addBtn);
    }

    /* Mantener el precio sincronizado si cambia la variante */
    doc.addEventListener('change', function (e) {
      if (!form.contains(e.target)) { return; }
      setTimeout(function () {
        var pe = doc.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular, .product .price .price-item');
        var t = bar.querySelector('[data-pdp-price]');
        if (pe && t) { t.textContent = pe.textContent.trim(); }
      }, 300);
    });
  })();

  /* ---------- 13. Filtro de color: el nombre también marca el filtro (Clarity 04/11/2026) ----------
     Solo respondía el circulito; pulsar «Amarillo (2)» no hacía nada (clic muerto). El
     formulario de filtros se vuelve a pintar al filtrar, por eso el escuchador va en document. */
  doc.addEventListener('click', function (e) {
    var txt = e.target.closest && e.target.closest('.facet-checkbox__text');
    if (!txt || txt.closest('label')) { return; }
    var fila = txt.closest('.facets__label');
    var input = fila ? fila.querySelector('input[type="checkbox"]') : null;
    if (input && !input.disabled) { input.click(); }
  });
})();
